import styled, { css } from 'styled-components';

const hideScrollbar = css`
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CategoryScrollContainer = styled.div`
  display: flex;
  margin-bottom: 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
`;

const generateResponsiveStyles = (props) => {
  return props.fitScreen
    ? css`
        flex-grow: 0;
        width: fit-content;
        max-width: auto;
      `
    : css`
        flex-grow: 1;
        width: 100%;
        max-width: none;
      `;
};
export const CategoryContainer = styled.div`
  display: flex;
  height: 42px;
  overflow-x: auto;
  gap: 8px;
  justify-content: ${(props) => (props.isOverflowing ? 'unset' : 'center')};
  ${(props) => props.isMobile && `margin-top: 12px;`}
  ${hideScrollbar}
  ${generateResponsiveStyles}
`;

export const ProductScrollContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
  justify-content: center;
  align-items: center;
`;

export const ProductList = styled.div`
  display: flex;
  height: 42px;
  overflow-x: auto;

  ${hideScrollbar}

  ${generateResponsiveStyles}
  ${(props) => {
    return props.isProductOverflowing
      ? `justify-constent: flex-start;`
      : `justify-constent: center;`;
  }}
`;

const baseButton = css`
  ${({ variant, selected, padding, borderRadius, border, background, color, fontWeight }) => {
    // Defaults
    let styles = {
      padding: '12px 20px',
      borderRadius: '40px',
      border: '1px solid #ccc',
      background: '#ffffff',
      color: 'black',
      fontWeight: 'normal',
    };

    if (variant === 'scroll') {
      styles = {
        padding: '6px 10px',
        borderRadius: '50px',
        background: '#ffffff',
        color: 'black',
        fontWeight: 'normal',
        border: '1px solid #DDD',
      };
    }

    if (variant === 'productScroll') {
      styles = {
        padding: '6px 10px',
        borderRadius: '0px',
      };
    }

    if (variant === 'category') {
      styles = {
        padding: '6px 18px',
        borderRadius: '0px',
      };
    }

    return `
      padding: ${padding || styles.padding};
      border-radius: ${borderRadius || styles.borderRadius};
      background: ${selected ? '#F3F3F3' : background || styles.background};
      color: ${selected ? 'black' : color || styles.color};
      font-weight: ${selected ? 'bold' : fontWeight || styles.fontWeight};
      border: ${selected ? '2px solid black' : border || styles.border};
    `;
  }}

  white-space: nowrap;
  text-align: center;
  cursor: pointer;
  flex-shrink: 0;
`;

export const StyledButton = styled.button`
  ${baseButton}
  width: ${(props) => props.width || 'auto'};
  height: ${(props) => props.height || '42px'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-family: Nunito;
  &:has(svg),
  &:only-child {
    min-width: 42px;
    padding: 0;
    border-radius: 6px;
  }
  ${(props) => props.variant === 'scroll' && `width: 42px;`}

  ${(props) =>
    props.softDisable &&
    `border: 1px dashed #DDD;
      opacity: 0.7;
    letter-spacing: 0.2px;
`}
  ${(props) => {
    return (
      props.secondCategory &&
      `
      padding: 12px;
      border-radius:0px;
      font-size: 12px;
      font-family: Nunito;
  `
    );
  }}
`;

export const SelectedChip = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-radius: 50px;
  font-size: 12px;
  background-color: white;
  font-family: Nunito;
  gap: 6px;
`;

export const RemoveChip = styled.button`
  background: none;
  border: none;
  font-size: 12px;
  cursor: pointer;
  color: #666;
  padding: 0;
`;

export const ClearAll = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.BLACK};
  font-family: ${({ theme }) => theme.fonts.secondaryFontFamily};
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
`;

// Define the styled component
export const StyledFilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  @media ${(props) => props.theme.mediaQuery.large} {
    margin-bottom: 32px;
  }
`;
